import React, { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export default function Support() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/config").then(({ data }) => setConfig(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-obsidian/70 border-b border-white/10">
        <div className="container mx-auto h-16 flex items-center justify-between px-4">
          <Logo />
        </div>
      </nav>

      <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32">
        <div className="relative z-10 max-w-3xl mx-auto px-6">
          <h1 className="text-4xl font-bold mb-8 text-center">Support</h1>

          <div className="space-y-8 text-gray-300 leading-7">
            {config ? (
              <section className="whitespace-pre-wrap">{config.support_page_content}</section>
            ) : (
              <div className="h-24 animate-pulse bg-white/5 rounded-xl" />
            )}

            {config && (config.support_email || config.support_phone) && (
              <section>
                <h2 className="text-2xl font-semibold mb-4">Get in Touch</h2>
                <div className="bg-zinc-900 rounded-xl p-6 space-y-2">
                  {config.support_email && (
                    <p>
                      Email: <a href={`mailto:${config.support_email}`} className="text-volt hover:underline">{config.support_email}</a>
                    </p>
                  )}
                  {config.support_phone && (
                    <p>
                      Phone: <a href={`tel:${config.support_phone}`} className="text-volt hover:underline">{config.support_phone}</a>
                    </p>
                  )}
                </div>
              </section>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
